/** @jsx jsx */
import { jsx } from '@emotion/core';
import Tooltip from '@atlaskit/tooltip';
import { fontSize } from '@atlaskit/theme/constants';
import { gs } from '../utils';
export var Metadata = function (_a) {
    var text = _a.text, icon = _a.icon, iconUrl = _a.iconUrl, tooltip = _a.tooltip;
    var metadataIcon = icon || null;
    if (!metadataIcon && iconUrl) {
        metadataIcon = jsx("img", { src: iconUrl, css: { width: gs(1), height: gs(1) } });
    }
    var metadata = (jsx("div", { css: { display: 'flex', alignItems: 'center', marginRight: gs(0.5) } },
        metadataIcon,
        jsx("span", { css: {
                fontSize: fontSize() + "px",
                marginRight: gs(0.5),
                marginLeft: '2px',
            } }, text)));
    if (tooltip) {
        return jsx(Tooltip, { content: tooltip }, metadata);
    }
    return metadata;
};
//# sourceMappingURL=Metadata.js.map